import pick from 'lodash/pick'
import { ProductSDK } from '@b2ag/module-product-sdk'
import * as productMapper from './product.mapper'

interface UpdateCooperativeProductPayload {
  is_highlighted?: boolean
  tips?: string
  upsides?: string
}

class ProductService {
  private readonly sdk: ProductSDK

  constructor({ productSdk }: { productSdk: ProductSDK }) {
    this.sdk = productSdk
  }

  async getV2(id: string, cooperativeId?: string) {
    if (cooperativeId) {
      const data = await this.sdk.getDistributorCatalogProduct({ cooperativeId, productId: id })
      if (!data) {
        throw new Error(`Product ${id} not found`)
      }
      return productMapper.mapFromCooperativeCatalogProduct(data)
    }

    const data = await this.sdk.getProduct(id)
    if (!data) {
      throw new Error(`Product ${id} not found`)
    }
    return productMapper.mapFromProduct(data)
  }

  async updateCatalogProduct(id: number, cooperativeId: string, cooperativeProduct: Record<string, unknown>) {
    const payload = pick(cooperativeProduct, ['tips', 'upsides', 'is_highlighted']) as UpdateCooperativeProductPayload
    const data = await this.sdk.updateDistributorProduct({ cooperativeId, productId: String(id) }, payload)
    return productMapper.mapFromUpdateCooperativeProductResponse(data)
  }

  async getProductsByInvivoIds(variantInvivoIdList: string[], cooperativeId: string) {
    const data = await this.sdk.getDistributorCatalogProducts({ cooperativeId }, { invivo_ids: variantInvivoIdList })
    return data.map((product) => productMapper.mapFromCooperativeCatalogProduct(product))
  }

  async associateProducts(cooperativeId: string, productId: number, associatedProductId: string): Promise<void> {
    await this.sdk.updateCooperativeSuggestedProducts(
      { cooperativeId, productId: String(productId) },
      { associated_product_id: associatedProductId },
    )
  }

  async unassociateProducts(cooperativeId: string, productId: number, associatedProductId: string): Promise<void> {
    await this.sdk.deleteDistributorSuggestedProduct(
      { cooperativeId, productId: String(productId) },
      { associated_product_id: associatedProductId },
    )
  }
}
export default ProductService
